import { render } from "./GeoRouting.vue?vue&type=template&id=0be19608"
import script from "./GeoRouting.vue?vue&type=script&lang=js"
export * from "./GeoRouting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__